import React from 'react';
import DeletedCycleContractItem from '../DeletedCycleContractItem/DeletedCycleContractItem';
import { useLoadContractScreens } from '../../hooks/useLoadContractScreens';
import { TAB_NUMBER } from '../../../ContractScreensView/constants';
import SpinnerLoader from '../../../../components/SpinnerLoader/SpinnerLoader';
import { useDeletedCycles } from './hooks/useDeletedCycles';
import filterCyclesByContract from '../../utils/getCyclesByContract';

const DeletedCycleContractList: React.FC = () => {
  const { contracts, isLoading: isLoadingContractData } = useLoadContractScreens({ tabNumber: TAB_NUMBER.DELETED });
  const { cycles } = useDeletedCycles();

  if (!contracts.length && isLoadingContractData) {
    return (
      <div className="flex flex-row items-center justify-center">
        <SpinnerLoader />
      </div>
    );
  }

  if (!contracts.length && !isLoadingContractData) {
    return null;
  }

  return (
    <ul className='c-deleted-cycle-contract-list flex flex-col gap-y-1 pb-1'>
      {contracts.map((contract) => (
        <DeletedCycleContractItem
          key={contract.id}
          contractId={contract.id}
          contractName={contract.name}
          cycles={filterCyclesByContract(cycles, contract.id)}
        />
      ))}
    </ul>
  );
};

export default DeletedCycleContractList;
